import React from 'react';
import { Typography } from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import './StockTypeTransferCell.css';
import OrderStatusCell from './OrderStatusCell';
import RenderSvg from '../renderSvg/RenderSvg';

// Define the configuration for the stock types
const stockTypeConfig = [
  {
    id: 'Unsellable',
    dmsLabel: 'Unsellable',
    dmsColor: '#FFFAF7',
    dmsLabelColor: '#C44C36'
  },
  {
    id: 'Returned',
    dmsLabel: 'Returned',
    dmsColor: '#FFF9EF',
    dmsLabelColor: '#CC911F'
  },
  {
    id: 'Available',
    dmsLabel: 'Available',
    dmsColor: '#F0FBFF',
    dmsLabelColor: '#17B4A3'
  }
];

interface StockTypeTransferCellProps {
  from: string;
  to: string;
}

const StockTypeTransferCell: React.FC<StockTypeTransferCellProps> = ({ from, to }) => {
  return (
    <div className="stock-type-transfer">
      <div className="ExpiryDateCell"
        style={{
          width:'6.5rem',
          border: '1px solid #DFE2E7',
        }}
      >
        <span>{from}</span>
      </div>
      <span style={{margin:'15px '}}>
        <RenderSvg  name={"exchangeIcon"} />
      </span>
      <OrderStatusCell statusId={to} orderStatusConfig={stockTypeConfig} />
    </div>
  );
};

export default StockTypeTransferCell;
